import { like } from '@infuse/api/common';
import { searchOrganisations } from '@infuse/api/iam/organisation';
import { searchTenants } from '@infuse/api/iam/tenant';

export interface MoveDestination {
  id: string;
  name: string;
  tenantId?: string;
  tenantName?: string;
}

export interface MoveDestinations {
  organisations: MoveDestination[];
  tenants: MoveDestination[];
}

/**
 * Searches for available destinations (tenants and organisations) for moving users.
 * Returns both domain-level and tenant-level organisations.
 */
export async function fetchMoveDestinations(query?: string, excludeTenant = false): Promise<MoveDestinations> {
  const filter = query ? like('lower(name)', `%${query.toLowerCase()}%`) : undefined;

  const [orgsResponse, tenantsResponse] = await Promise.all([
    searchOrganisations({ size: 20, page: 0, filter }),
    excludeTenant
      ? Promise.resolve({ content: [] as { id: string; name: string }[] })
      : searchTenants({ size: 20, page: 0, filter })
  ]);

  return {
    organisations: orgsResponse.content.map((org) => ({
      id: org.id,
      name: org.name,
      tenantId: org.tenantId,
      tenantName: org.tenantName
    })),
    tenants: tenantsResponse.content.map((tenant) => ({
      id: tenant.id,
      name: tenant.name
    }))
  };
}
